import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { CreateBoardForm } from "./CreateBoardForm";
import { canCreateBoard } from "@/utils/planLimits";
import { UpgradePrompt } from "@/components/shared/UpgradePrompt";

type CreateBoardDialogProps = {
  companyId: string;
  companyPlan: string;
  currentBoardCount: number;
  onBoardCreated: () => void;
};

export const CreateBoardDialog = ({ companyId, companyPlan, currentBoardCount, onBoardCreated }: CreateBoardDialogProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showUpgradePrompt, setShowUpgradePrompt] = useState(false);
  const [upgradeMessage, setUpgradeMessage] = useState("");

  const handleOpen = () => {
    const check = canCreateBoard(companyPlan, currentBoardCount);
    if (!check.allowed) {
      setUpgradeMessage(check.message || "");
      setShowUpgradePrompt(true);
      return;
    }
    setIsOpen(true);
  };

  return (
    <>
      <Button onClick={handleOpen}>
        <Plus className="w-4 h-4 mr-2" />
        New Board
      </Button>

      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Create New Board</DialogTitle>
          </DialogHeader>
          <CreateBoardForm 
            companyId={companyId} 
            onSuccess={() => {
              setIsOpen(false);
              onBoardCreated();
            }} 
          />
        </DialogContent>
      </Dialog>

      <UpgradePrompt
        open={showUpgradePrompt}
        onOpenChange={setShowUpgradePrompt}
        message={upgradeMessage}
      />
    </>
  );
};